import {Pipe, Injectable, PipeTransform} from '@angular/core'

@Pipe({
  name: 'capitalize',
  pure: true
})
@Injectable()
export class CapitalizePipe implements PipeTransform {
  transform(phrase: string): any {
    return phrase.charAt(0).toUpperCase() + phrase.slice(1)
  }
}
export default CapitalizePipe
